'use client';

import React from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { SxProps } from '@mui/material/styles';
import toast from 'react-hot-toast';

interface Props {
  color?: string;
  size?: IconButtonProps['size'];
  sx?: SxProps;
  text: string;
}

export function CopyToClipboardButton({ color, size, text }: Props) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard');
  };

  return navigator ? (
    <IconButton
      aria-label="copy"
      onClick={handleClick}
      size={size}
      sx={{
        cursor: 'pointer',
      }}
    >
      <ContentCopyIcon fontSize={size} sx={{ color }} />
    </IconButton>
  ) : null;
}
